import React from "react";
import { Home } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Config } from "../../Config";

const NotFound = () => {

  return (
    <>
      <Helmet>
        <title>Not Found | {Config?._AppName}</title>
      </Helmet>
      <div className="flex items-center justify-center flex-col h-[100vh]">
        <svg xmlns="http://www.w3.org/2000/svg" width="95" height="95" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-frown text-red-600">
          <circle cx="12" cy="12" r="10"/>
          <path d="M16 16s-1.5-2-4-2-4 2-4 2"/>
          <line x1="9" x2="9.01" y1="9" y2="9"/>
          <line x1="15" x2="15.01" y1="9" y2="9"/>
        </svg>
        <br />
        <p className="text-2xl text-gray-500">404 - PAGE NOT FOUND</p>
        <p className="text-gray-500">Sorry, the page you're looking for doesn't exist.</p>
        <br /><br />
        <Link to="/">
          <button
            type="button"
            className="inline-flex items-center gap-x-2 rounded bg-green-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            <Home width={18} height={18} aria-hidden="true" className="-ml-0.5" />
            Home
          </button>
        </Link>
      </div>
    </>
  );
};

export default NotFound;
